<button class="make-payment__card">
  <div class="card__column-1">
    <img 
      class="card__logo"
      src="/assets/imgs/mpass-logo.svg" 
      [alt]="'MPASS logo' | translate"
    >
    
    <ul class="card__user-info">
      <li>
        <p class="card__user-name ci-paragraph-p1-semibold">
          {{ 'Mpass user name' }}
        </p>
      </li>

      <li>
        <p class="ci-footer-regular">
          {{ 'Mpass user email' }}
        </p>
      </li>
      
      <li>
        <p class="ci-caption-semibold">
          {{ 'Mpass user points' }}
        </p>
      </li>
    </ul>
  </div>
  
  <div class="card__content">
    <img 
      class="card__logo"
      src="/assets/imgs/qr-hardcoded.webp" 
      [alt]="'MPASS qr' | translate"
    >
  </div>
</button>